import { useEffect, useState } from 'react';

export type Route =
  | { name: 'home' }
  | { name: 'takes' }
  | { name: 'moderation' }
  | { name: 'room'; roomId: string }
  | { name: 'receipt'; roomId: string }
  | { name: 'catchup'; roomId: string }
  | { name: 'story'; storyId: string }
  | { name: 'control'; roomId?: string };

export function parseRoute(pathname: string, search = ''): Route {
  const parts = pathname.split('/').filter(Boolean).map(decodeURIComponent);
  if (parts[0] === 'takes') return { name: 'takes' };
  if (parts[0] === 'moderation') return { name: 'moderation' };
  if (parts[0] === 'story' && parts[1]) return { name: 'story', storyId: parts[1] };
  if (parts[0] === 'room' && parts[1]) return parts[2] === 'receipt' ? { name: 'receipt', roomId: parts[1] } : parts[2] === 'catchup' ? { name: 'catchup', roomId: parts[1] } : { name: 'room', roomId: parts[1] };
  if (parts[0] === 'control') {
    const roomId = new URLSearchParams(search).get('room') ?? undefined;
    return roomId ? { name: 'control', roomId } : { name: 'control' };
  }
  return { name: 'home' };
}

export function navigate(path: string): void {
  history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.scrollTo(0, 0);
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(location.pathname, location.search));
  useEffect(() => {
    const on = () => setRoute(parseRoute(location.pathname, location.search));
    window.addEventListener('popstate', on);
    return () => window.removeEventListener('popstate', on);
  }, []);
  return route;
}
